var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{attrs:{"status":"404","title":"404","sub-title":"Sorry, the page you visited does not exist."}})
}
var staticRenderFns = []

export { render, staticRenderFns }